

//Modules
import { Box , CircularProgress, Modal, Typography } from "@mui/material"
import { useEffect, useState , useContext } from "react"
import { useNavigate } from "react-router-dom"

//Interfaces
import { i_question } from "../interfaces/items.interface"
import { i_user } from "../interfaces/user.interface"

//Utils
import { handleFetch } from "../api/fetch"

//Components
import Footer from "../components/utils/footer"

//Context
import { MainContext } from "../context/context"
import { delay } from "../utils/utility"
import { i_alert, i_alert_control } from "../interfaces/utility.interface"
import { default_alert, default_user } from "../utils/constant"
import AlertTop from "../components/utils/alert"
import UserViewModal from "../components/modal/user.view"
import { i_user_view_modal } from "../interfaces/display.interfaces"



const Message = () => {
    const [ loading , setLoading ] = useState<boolean>(false)
    const [ alert , setAlert ] = useState<i_alert>(default_alert)
    const [ data , setData ] = useState<i_question[]>([])
    const [ users , setUsers ] = useState<i_user[]>()
    const [ open , setOpen ] = useState<boolean>(false)
    const [ selectedUser, setSelectedUser ] = useState<i_user>(default_user)
    const { HandleLogout } = useContext(MainContext)
    const nav = useNavigate()
    useEffect(() => {
        const getQuestions = async() => {
            setLoading(true)
            await delay(1000)
            const res = await handleFetch('/questions' , 'GET' , true , null)
            if(res.type === 'Success'){
                setData(res.data)
            }else{
                if(res.type === 'Unauthorized'){
                    HandleLogout(nav)
                } else{
                }
            }
            setLoading(false)
        }
        const getUsers = async() => {
            const res = await handleFetch('/users/worker', 'GET', true, null)
            if(res.type === 'Success'){
                setData(res.data)
            }
        }
        getQuestions()
        getUsers()
    },[])
    const alert_props : i_alert_control = {
        alert : alert,
        onClose : () => setAlert(default_alert),
        float : 'top',
        top: 125
    }
    const userViewModal : i_user_view_modal = {
        user: selectedUser,
        open : open,
        setOpen : setOpen,
    }
    return (
        <Box>
            <AlertTop {...alert_props}/>
            <Box sx={{position: 'sticky', top: 0, height: '91.5vh', overflowY: 'auto'}}>
                {loading ?
                    <Box sx={{ display : 'flex' , justifyContent : 'center' , marginTop : '40vh'}}>
                        <CircularProgress size={100}/>
                    </Box>
                :
                <Box>
                    <Box>
                        {data.map((item : i_question , index : number) => (
                            <Box key={index} sx={{ padding : 1 , border : '1px solid gray', marginBottom : 1 }}>
                                <Box sx={{ display : 'flex', justifyContent : 'space-between', alignItems : 'center'}}>
                                    <Box>{item.subject}</Box>
                                    <Box>{item.message}</Box>
                                </Box>
                            </Box>
                        ))}
                        <Box sx={{ display : 'flex' , justifyContent : 'center' , marginTop : '5vh'}}>
                            <Typography>Here we could show all message incoming for orders... or account questions..</Typography>
                        </Box>
                    </Box>

                </Box>
                }
            </Box>
            <UserViewModal { ...userViewModal} />
            <Footer/>
        </Box>
    )
}

export default Message